import { Photos } from 'components/page/ForeignProfile/common.types'

export const filteredPortraitNotMainPhotos = (photos: Photos): Photos =>
  photos.filter(({ main, portrait }) => !main && portrait)

export const filteredRestPhotos = (photos: Photos): Photos =>
  photos.filter(({ main, portrait }) => !main && !portrait)
